// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainSidebar {
  position: sticky;
  top: 0;
  align-self: flex-start;
  width: 232px;
  min-width: 232px;
  z-index: 1000;
}

.mainSidebar__card {
  border-radius: 18px !important;
  border: 1px solid #d9e7fb !important;
  box-shadow: 0 18px 42px rgba(18, 57, 110, 0.14) !important;
  overflow: hidden;
  background: linear-gradient(180deg, #fbfdff 0%, #eef4ff 100%) !important;
}
.mainSidebar__card .ant-card-body {
  min-height: 100vh;
  padding: 14px 12px 20px !important;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mainSidebar__userBlock {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
}

.mainSidebar__logoLink {
  width: 100%;
  justify-content: flex-start;
  border-right: none !important;
  padding: 8px 10px 10px;
}

.mainSidebar__logo {
  width: 148px;
}

.mainSidebar__userTrigger {
  width: 100%;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.mainSidebar__userTrigger:hover {
  background: rgba(45, 102, 196, 0.08);
  border-color: transparent;
}

.mainSidebar__userTrigger[aria-expanded=true] {
  box-shadow: none;
}

.mainSidebar__userAvatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.mainSidebar__userInfo {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}

.mainSidebar__userName {
  color: #1f3560;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  white-space: normal;
  overflow-wrap: anywhere;
}

.mainSidebar__userRole {
  color: #637899;
  font-size: 12px;
  line-height: 1.2;
  white-space: normal;
  overflow-wrap: anywhere;
}

.mainSidebar__userChevron {
  color: #2d66c4;
  font-size: 14px;
  transition: transform 0.26s ease;
}

.mainSidebar__userTrigger[aria-expanded=true] .mainSidebar__userChevron {
  transform: rotate(180deg);
}

.mainSidebar__userMenu {
  margin: 0;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.mainSidebar__userMenu .ant-btn {
  width: 100%;
  justify-content: flex-start;
  padding: 0 14px !important;
  height: 42px;
  color: #1f3560 !important;
  font-size: 16px;
  font-weight: 500;
  border-radius: 10px !important;
  background: transparent !important;
  box-shadow: none !important;
}

.mainSidebar__userMenu .ant-btn:hover {
  background: rgba(45, 102, 196, 0.12) !important;
}

.mainSidebar__userMenu .ant-btn + .ant-btn {
  margin-top: 4px;
}

.mainSidebar__userDivider {
  height: 1px;
  width: 100%;
  background: rgba(45, 102, 196, 0.16);
}

.mainSidebar__menu.ant-menu {
  border-inline-end: none !important;
  background: transparent !important;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 8px 0 0;
}

.mainSidebar__menu .ant-menu-item {
  border-radius: 10px;
  margin: 4px 0;
  height: 42px;
  line-height: 42px;
  font-weight: 500;
  color: #1f3560;
  transition: all 0.2s ease;
}

.mainSidebar__menu .ant-menu-item .ant-menu-item-icon {
  color: #2d66c4;
}

.mainSidebar__menu .ant-menu-item:hover {
  background: rgba(45, 102, 196, 0.12);
}

.mainSidebar__menu .ant-menu-item-selected {
  background: linear-gradient(90deg, #2d66c4 0%, #4f8df0 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 8px 20px rgba(45, 102, 196, 0.3);
}

.mainSidebar__menu .ant-menu-item-selected .ant-menu-item-icon {
  color: #ffffff;
}

.mainSidebar__drawer .ant-drawer-content-wrapper {
  margin-left: 236px;
  width: min(360px, 100vw - 260px) !important;
}

.mainSidebar__drawer .ant-drawer-content {
  background: linear-gradient(180deg, #ffffff 0%, #f2f7ff 100%);
}

.mainSidebar__drawer .ant-drawer-header {
  border-bottom: 1px solid #d9e7fb;
  padding: 18px 20px 12px;
}

.mainSidebar__drawer .ant-drawer-body {
  padding: 14px 14px 20px;
}

.mainSidebar__drawerTitle {
  color: #20427a;
  font-weight: 700;
  font-size: 16px;
  text-transform: capitalize;
}

.mainSidebar__submenu.ant-menu {
  border-inline-end: none !important;
  background: transparent !important;
  overflow-y: auto;
  max-height: calc(100vh - 132px);
}

.mainSidebar__submenu .ant-menu-item,
.mainSidebar__submenu .ant-menu-submenu-title {
  border-radius: 10px;
  margin: 3px 0;
  color: #2c405f;
  font-weight: 500;
}

.mainSidebar__submenu .ant-menu-submenu-arrow {
  color: #2d66c4 !important;
}

.mainSidebar__submenu .ant-menu-item-selected {
  background: rgba(45, 102, 196, 0.14) !important;
  color: #1e4ea4 !important;
}

.mainSidebar__submenuLoader {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1199.98px) {
  .mainSidebar {
    width: 92px;
    min-width: 92px;
  }
  .mainSidebar__logoLink,
  .mainSidebar__userDivider {
    display: none;
  }
  .mainSidebar__menu .ant-menu-title-content {
    display: none;
  }
  .mainSidebar__menu .ant-menu-item {
    display: flex;
    justify-content: center;
  }
  .mainSidebar__menu .ant-menu-item .ant-menu-item-icon {
    margin-inline-end: 0;
  }
  .mainSidebar__drawer .ant-drawer-content-wrapper {
    margin-left: 98px;
    width: min(340px, 100vw - 118px) !important;
  }
}
@media screen and (max-width: 767.98px) {
  .mainSidebar {
    width: 74px;
    min-width: 74px;
  }
  .mainSidebar__card .ant-card-body {
    padding: 10px 8px 14px !important;
  }
  .mainSidebar__drawer .ant-drawer-content-wrapper {
    margin-left: 0;
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/SideBar.sass"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,MAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AACF;;AACA;EACE,8BAAA;EACA,oCAAA;EACA,0DAAA;EACA,gBAAA;EACA,wEAAA;AAEF;AAAE;EACE,iBAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAEJ;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAGF;;AADA;EACE,WAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAHA;EACE,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,8EAAA;AAMF;;AAJA;EACE,oCAAA;EACA,yBAAA;AAOF;;AALA;EACE,gBAAA;AAQF;;AANA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AASF;;AAPA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAUF;;AARA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AAWF;;AATA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAYF;;AAVA;EACE,cAAA;EACA,eAAA;EACA,gCAAA;AAaF;;AAXA;EACE,yBAAA;AAcF;;AAZA;EACE,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,2BAAA;AAeF;;AAbA;EACE,WAAA;EACA,2BAAA;EACA,0BAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,2BAAA;AAgBF;;AAdA;EACE,+CAAA;AAiBF;;AAfA;EACE,eAAA;AAkBF;;AAhBA;EACE,WAAA;EACA,WAAA;EACA,oCAAA;AAmBF;;AAjBA;EACE,kCAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAoBF;;AAlBA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AAqBF;;AAnBA;EACE,cAAA;AAsBF;;AApBA;EACE,oCAAA;AAuBF;;AArBA;EACE,uEAAA;EACA,yBAAA;EACA,8CAAA;AAwBF;;AAtBA;EACE,cAAA;AAyBF;;AAvBA;EACE,kBAAA;EACA,2CAAA;AA0BF;;AAxBA;EACE,6DAAA;AA2BF;;AAzBA;EACE,gCAAA;EACA,uBAAA;AA4BF;;AA1BA;EACE,uBAAA;AA6BF;;AA3BA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AA8BF;;AA5BA;EACE,kCAAA;EACA,kCAAA;EACA,gBAAA;EACA,+BAAA;AA+BF;;AA7BA;;EAEE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AAgCF;;AA9BA;EACE,yBAAA;AAiCF;;AA/BA;EACE,+CAAA;EACA,yBAAA;AAkCF;;AAhCA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAmCF;;AAjCA;EACE;IACE,WAAA;IACA,eAAA;EAoCF;EAlCA;;IAEE,aAAA;EAoCF;EAlCA;IACE,aAAA;EAoCF;EAlCA;IACE,aAAA;IACA,uBAAA;EAoCF;EAlCA;IACE,oBAAA;EAoCF;EAlCA;IACE,iBAAA;IACA,2CAAA;EAoCF;AACF;AAnCA;EACE;IACE,WAAA;IACA,eAAA;EAqCF;EAnCA;IACE,iCAAA;EAqCF;EAnCA;IACE,cAAA;IACA,sBAAA;EAqCF;AACF","sourcesContent":[".mainSidebar\n  position: sticky\n  top: 0\n  align-self: flex-start\n  width: 232px\n  min-width: 232px\n  z-index: 1000\n\n.mainSidebar__card\n  border-radius: 18px !important\n  border: 1px solid #d9e7fb !important\n  box-shadow: 0 18px 42px rgba(18, 57, 110, 0.14) !important\n  overflow: hidden\n  background: linear-gradient(180deg, #fbfdff 0%, #eef4ff 100%) !important\n\n  .ant-card-body\n    min-height: 100vh\n    padding: 14px 12px 20px !important\n    display: flex\n    flex-direction: column\n    gap: 8px\n\n.mainSidebar__userBlock\n  display: flex\n  align-items: center\n  gap: 10px\n  padding: 8px 10px\n\n.mainSidebar__logoLink\n  width: 100%\n  justify-content: flex-start\n  border-right: none !important\n  padding: 8px 10px 10px\n\n.mainSidebar__logo\n  width: 148px\n\n.mainSidebar__userTrigger\n  width: 100%\n  border: 1px solid transparent\n  border-radius: 10px\n  background: transparent\n  padding: 0\n  cursor: pointer\n  text-align: left\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease\n\n.mainSidebar__userTrigger:hover\n  background: rgba(45, 102, 196, 0.08)\n  border-color: transparent\n\n.mainSidebar__userTrigger[aria-expanded=\"true\"]\n  box-shadow: none\n\n.mainSidebar__userAvatar\n  width: 40px\n  height: 40px\n  min-width: 40px\n  border-radius: 50%\n  object-fit: cover\n\n.mainSidebar__userInfo\n  display: flex\n  flex-direction: column\n  min-width: 0\n  flex: 1 1 auto\n\n.mainSidebar__userName\n  color: #1f3560\n  font-size: 14px\n  font-weight: 600\n  line-height: 1.25\n  white-space: normal\n  overflow-wrap: anywhere\n\n.mainSidebar__userRole\n  color: #637899\n  font-size: 12px\n  line-height: 1.2\n  white-space: normal\n  overflow-wrap: anywhere\n\n.mainSidebar__userChevron\n  color: #2d66c4\n  font-size: 14px\n  transition: transform 0.26s ease\n\n.mainSidebar__userTrigger[aria-expanded=\"true\"] .mainSidebar__userChevron\n  transform: rotate(180deg)\n\n.mainSidebar__userMenu\n  margin: 0\n  border: none !important\n  border-radius: 0 !important\n  background: transparent !important\n  box-shadow: none !important\n\n.mainSidebar__userMenu .ant-btn\n  width: 100%\n  justify-content: flex-start\n  padding: 0 14px !important\n  height: 42px\n  color: #1f3560 !important\n  font-size: 16px\n  font-weight: 500\n  border-radius: 10px !important\n  background: transparent !important\n  box-shadow: none !important\n\n.mainSidebar__userMenu .ant-btn:hover\n  background: rgba(45, 102, 196, 0.12) !important\n\n.mainSidebar__userMenu .ant-btn + .ant-btn\n  margin-top: 4px\n\n.mainSidebar__userDivider\n  height: 1px\n  width: 100%\n  background: rgba(45, 102, 196, 0.16)\n\n.mainSidebar__menu.ant-menu\n  border-inline-end: none !important\n  background: transparent !important\n  flex: 1 1 auto\n  overflow-y: auto\n  padding: 8px 0 0\n\n.mainSidebar__menu .ant-menu-item\n  border-radius: 10px\n  margin: 4px 0\n  height: 42px\n  line-height: 42px\n  font-weight: 500\n  color: #1f3560\n  transition: all 0.2s ease\n\n.mainSidebar__menu .ant-menu-item .ant-menu-item-icon\n  color: #2d66c4\n\n.mainSidebar__menu .ant-menu-item:hover\n  background: rgba(45, 102, 196, 0.12)\n\n.mainSidebar__menu .ant-menu-item-selected\n  background: linear-gradient(90deg, #2d66c4 0%, #4f8df0 100%) !important\n  color: #ffffff !important\n  box-shadow: 0 8px 20px rgba(45, 102, 196, 0.3)\n\n.mainSidebar__menu .ant-menu-item-selected .ant-menu-item-icon\n  color: #ffffff\n\n.mainSidebar__drawer .ant-drawer-content-wrapper\n  margin-left: 236px\n  width: min(360px, calc(100vw - 260px)) !important\n\n.mainSidebar__drawer .ant-drawer-content\n  background: linear-gradient(180deg, #ffffff 0%, #f2f7ff 100%)\n\n.mainSidebar__drawer .ant-drawer-header\n  border-bottom: 1px solid #d9e7fb\n  padding: 18px 20px 12px\n\n.mainSidebar__drawer .ant-drawer-body\n  padding: 14px 14px 20px\n\n.mainSidebar__drawerTitle\n  color: #20427a\n  font-weight: 700\n  font-size: 16px\n  text-transform: capitalize\n\n.mainSidebar__submenu.ant-menu\n  border-inline-end: none !important\n  background: transparent !important\n  overflow-y: auto\n  max-height: calc(100vh - 132px)\n\n.mainSidebar__submenu .ant-menu-item,\n.mainSidebar__submenu .ant-menu-submenu-title\n  border-radius: 10px\n  margin: 3px 0\n  color: #2c405f\n  font-weight: 500\n\n.mainSidebar__submenu .ant-menu-submenu-arrow\n  color: #2d66c4 !important\n\n.mainSidebar__submenu .ant-menu-item-selected\n  background: rgba(45, 102, 196, 0.14) !important\n  color: #1e4ea4 !important\n\n.mainSidebar__submenuLoader\n  min-height: 180px\n  display: flex\n  align-items: center\n  justify-content: center\n\n@media screen and (max-width: 1199.98px)\n  .mainSidebar\n    width: 92px\n    min-width: 92px\n\n  .mainSidebar__logoLink,\n  .mainSidebar__userDivider\n    display: none\n\n  .mainSidebar__menu .ant-menu-title-content\n    display: none\n\n  .mainSidebar__menu .ant-menu-item\n    display: flex\n    justify-content: center\n\n  .mainSidebar__menu .ant-menu-item .ant-menu-item-icon\n    margin-inline-end: 0\n\n  .mainSidebar__drawer .ant-drawer-content-wrapper\n    margin-left: 98px\n    width: min(340px, calc(100vw - 118px)) !important\n\n@media screen and (max-width: 767.98px)\n  .mainSidebar\n    width: 74px\n    min-width: 74px\n\n  .mainSidebar__card .ant-card-body\n    padding: 10px 8px 14px !important\n\n  .mainSidebar__drawer .ant-drawer-content-wrapper\n    margin-left: 0\n    width: 100% !important\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
